import { Link, useSearchParams } from "react-router-dom";
import { Card, CardContent } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { XCircle, ArrowLeft } from "lucide-react";

const BookingCancel = () => {
  const [searchParams] = useSearchParams();
  const bookingId = searchParams.get("booking_id");

  return (
    <div className="min-h-screen bg-slate-50 flex items-center justify-center p-4" data-testid="booking-cancel-page">
      <Card className="max-w-md w-full animate-fadeIn">
        <CardContent className="py-12 text-center">
          <div className="h-16 w-16 rounded-full bg-red-100 flex items-center justify-center mx-auto mb-4">
            <XCircle className="h-8 w-8 text-red-600" />
          </div>
          <h2 className="text-2xl font-bold text-slate-900 mb-2" style={{ fontFamily: 'Manrope, sans-serif' }}>
            Pagamento Annullato
          </h2>
          <p className="text-slate-500 mb-6">
            Il pagamento è stato annullato. La tua prenotazione non è stata completata.
          </p>

          <div className="flex flex-col gap-3">
            <Button variant="outline" onClick={() => window.history.back()} data-testid="try-again-btn">
              <ArrowLeft className="h-4 w-4 mr-2" />
              Riprova
            </Button>
            <Link to="/">
              <Button variant="ghost" className="w-full" data-testid="back-home-btn">
                Torna alla Home
              </Button>
            </Link>
          </div>
        </CardContent>
      </Card>
    </div>
  );
};

export default BookingCancel;
